import { useNavigate } from 'react-router-dom'
import { useStepbarStore } from '@/store/useStepbarStore'

export const useStepAction = (actionHref: string) => {
  const navigate = useNavigate()
  const setSelectedStep = useStepbarStore((state) => state.setSelectedStep)

  const handleSelectStep = (evt) => {
    setSelectedStep(evt.detail)
  }

  const handleClickAction = () => {
    setSelectedStep(null)
    navigate(actionHref)
  }

  return {
    handleClickAction,
    handleSelectStep
  }
}
